"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const CloseIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.62274 5.27842C6.25152 4.90719 5.64965 4.90719 5.27842 5.27842C4.9072 5.64964 4.9072 6.25151 5.27842 6.62273L10.6557 12L5.27842 17.3773C4.90719 17.7485 4.90719 18.3504 5.27842 18.7216C5.64964 19.0928 6.25151 19.0928 6.62273 18.7216L12 13.3443L17.3773 18.7216C17.7485 19.0928 18.3504 19.0928 18.7216 18.7216C19.0928 18.3503 19.0928 17.7485 18.7216 17.3772L13.3443 12L18.7216 6.62276C19.0928 6.25154 19.0928 5.64967 18.7216 5.27845C18.3503 4.90723 17.7485 4.90722 17.3773 5.27845L12 10.6557L6.62274 5.27842Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.CloseIcon = CloseIcon;
//# sourceMappingURL=close_icon.js.map